import React, {useState} from "react";
import PropTypes from "prop-types";
import {css} from "@emotion/react";
import {breakpoints} from "~styles/global";
import Button from "~components/blocks/Button";
import RichText from "~components/RichText";
import axios from "axios";
const NewsletterSignupForm = ({className, successMessage, buttonText, heading, centered}) => {
  const {mobile} = breakpoints;
  const [values, setValues] = useState({});
  const [errors, setErrors] = useState([]);
  const [success, setSuccess] = useState(false);

  const validate = (e) => {
    e.preventDefault();
    const newErrors = [];

    if (!values.email)
      newErrors.push({
        field: "email",
        message: "The email field is required",
      });

    if (values.email && (!values.email.includes("@") || !values.email.includes(".")))
      newErrors.push({
        field: "email",
        message: "Please check your email address",
      });

    if (!values.accountType)
      newErrors.push({
        field: "accountType",
        message: "Account Type is required",
      });

    if (newErrors.length === 0) {
      submit();
    } else {
      setErrors(newErrors);
    }
  };

  const submit = () => {
    axios
      .post("/api/subscribe", {
        email: values.email,
        firstName: values.fname,
        lastName: values.lname,
        accountType: values.accountType,
      })
      .then((_response) => {
        setSuccess(true);
      })
      .catch((error) => {
        setErrors([
          {
            field: null,
            message: error.response.data.response.title,
          },
        ]);
      });

    // sendToMailchimp(values.email, values.fname, values.lname, (err, data) => {
    //   if (err) {
    //     console.log(err, data);
    //     setErrors([
    //       {
    //         field: null,
    //         message: "Sorry we can't sign you up right now.",
    //       },
    //     ]);
    //   } else {
    //     setSuccess(true);
    //   }
    // });
  };

  const errorFields = errors.map((error) => error.field);

  return (
    <div
      className={className}
      css={css`
        position: relative;
        h6 {
          margin-bottom: 18px;
        }
        input {
          ${mobile} {
            margin-bottom: 20px;
          }
        }
      `}
    >
      <h5
        css={css`
          opacity: ${success ? "1" : "0"};
          transition: opacity 0.3s 0.3s;
          pointer-events: ${success ? "all" : "none"};
        `}
      >
        <RichText content={successMessage} />
      </h5>
      <div
        css={css`
          opacity: ${success ? "0" : "1"};
          transition: opacity 0.3s;
          pointer-events: ${success ? "none" : "all"};
        `}
      >
        {heading && <h6>{heading}</h6>}
        <form onSubmit={(e) => validate(e)} noValidate>
          <input
            type="text"
            name="fname"
            placeholder="First Name"
            onChange={(e) => setValues({...values, fname: e.target.value})}
          />
          <input
            type="text"
            name="lname"
            placeholder="Last Name"
            onChange={(e) => setValues({...values, lname: e.target.value})}
          />
          <input
            type="email"
            name="email"
            placeholder="Email*"
            css={css`
              border-color: ${errorFields.includes("email") ? "var(--orange)" : "var(--black)"};
            `}
            onChange={(e) => setValues({...values, email: e.target.value})}
          />
          <div
            css={css`
              display: flex;
              align-items: center;
              margin-bottom: 20px;
              gap: 10px;
            `}
          >
            <p style={{fontSize: "13px"}}>Account Type</p>
            <label
              css={css`
                font-size: 13px;
                display: flex;
                align-items: center;
                gap: 4px;
              `}
            >
              <input
                type="radio"
                name="accountType"
                value="trade"
                style={{width: "13px", height: "13px", margin: "0px", accentColor: "var(--black)"}}
                onChange={(e) => setValues({...values, accountType: e.target.value})}
              />
              Trade
            </label>
            <label
              css={css`
                font-size: 13px;
                display: flex;
                align-items: center;
                gap: 4px;
              `}
            >
              <input
                type="radio"
                name="accountType"
                value="retail"
                style={{width: "13px", height: "13px", margin: "0px", accentColor: "var(--black)"}}
                onChange={(e) => setValues({...values, accountType: e.target.value})}
              />
              Retail
            </label>
          </div>
          {errors?.length > 0 && (
            <div
              css={css`
                grid-column: span 2;
                margin-top: -10px;
                margin-bottom: 20px;
                color: var(--orange);
              `}
            >
              {errors.map((error) => (
                <p className="h5">{error.message}</p>
              ))}
            </div>
          )}
          <Button
            onClick={() => console.log("values", values)}
            type="submit"
            css={css`
              margin: ${centered ? "0 auto" : "0"};
            `}
          >
            {buttonText ? buttonText : "Go"}
          </Button>
        </form>
      </div>
    </div>
  );
};

NewsletterSignupForm.propTypes = {
  successMessage: PropTypes.array,
  buttonText: PropTypes.string,
  centered: PropTypes.bool,
};

NewsletterSignupForm.defaultProps = {};

export default NewsletterSignupForm;
